import React from 'react';
import { useTranslation } from 'react-i18next';
import { s } from '../helpers';

export interface PerfTabItem {
  label: string;
  bg: string;
  color: string;
  onClick: () => void;
}

export interface PerformanceChartProps {
  openPerf: () => void;
  perfTabs: PerfTabItem[];
  perfRef: React.RefObject<HTMLCanvasElement>;
  perfBarLabel?: string;
  perfLineLabel?: string;
}

export const PerformanceChart: React.FC<PerformanceChartProps> = ({
  openPerf,
  perfTabs,
  perfRef,
  perfBarLabel,
  perfLineLabel
}) => {
  const { t } = useTranslation();

  return (
    <section
      style={s(
        `background:#FFFEFB;border:1px solid #EFE6D6;border-radius:12px;box-shadow:0 1px 3px rgba(120,90,30,0.06);padding:16px 18px;min-width:0;display:flex;flex-direction:column;gap:10px`
      )}
    >
      <div style={s(`display:flex;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap`)}>
        <h2
          style={s(
            `margin:0;font-size:14px;font-weight:700;color:#1B1B1B;text-transform:uppercase;letter-spacing:0.01em`
          )}
        >
          {t('managerNetwork.perf.title', 'Performance Over Time')}
        </h2>
        <button
          onClick={openPerf}
          style={s(
            `border:0;background:transparent;color:#8C6424;font-size:11.5px;cursor:pointer;display:flex;align-items:center;gap:4px;padding:0`
          )}
        >
          {t('managerNetwork.perf.details', 'Chi tiết')}<i className="icon-arrow-right"></i>
        </button>
      </div>
      <div style={s(`display:flex;gap:4px`)}>
        {perfTabs?.map((pt, pt_idx) => (
          <React.Fragment key={pt_idx}>
            <button
              onClick={pt.onClick}
              style={s(
                `height:28px;padding:0 14px;border:0;border-radius:4px;background:${pt.bg};color:${pt.color};font-size:12px;font-weight:500;cursor:pointer`
              )}
            >
              {pt.label}
            </button>
          </React.Fragment>
        ))}
      </div>
      <div style={s(`position:relative;height:170px;min-width:0;overflow:hidden`)}>
        <canvas ref={perfRef}></canvas>
      </div>
      <div style={s(`display:flex;flex-wrap:wrap;gap:18px;justify-content:center;font-size:11.5px;color:#3A342C`)}>
        <span style={s(`display:flex;align-items:center;gap:6px`)}>
          <span style={s(`width:10px;height:10px;border-radius:2px;background:#D4AC66`)}></span>
          {perfBarLabel}
        </span>
        <span style={s(`display:flex;align-items:center;gap:6px`)}>
          <span
            style={s(
              `position:relative;width:18px;height:2px;background:#1B1B1B;display:flex;align-items:center;justify-content:center`
            )}
          >
            <span style={s(`width:6px;height:6px;border-radius:50%;background:#1B1B1B`)}></span>
          </span>
          {perfLineLabel}
        </span>
      </div>
    </section>
  );
};
